/**
 * Determines if the response is an AxiosResponse object.
 * @param response an object matching the AxiosResponse interface
 * @returns boolean
 */
export const isAxiosResponse = (response: unknown) => {
  try {
    if (response && !Array.isArray(response) && typeof response === 'object') {
      const keys = Object.keys(response);
      const axiosKeys = ['data', 'status', 'statusText', 'headers', 'config', 'request'];
      return keys.length === axiosKeys.length && keys.every((key) => axiosKeys.includes(key));
    }

    return false;
  } catch (err) {
    console.error(`[AdvancedSearchParser] Error determining response type 'Axios': ${err}`);
    return false;
  }
};

export const isAdvancedSearchResponseObject = (response: unknown) => {
  try {
    if (response && typeof response === 'object' && !Array.isArray(response)) {
      return Object.keys(response).some((key) => {
        return key === '_' || key === 'isCacheHit' || key === 'searchType' || key === 'responseStats';
      });
    }

    return false;
  } catch (err) {
    console.error(`[AdvancedSearchParser] Error determining response type 'Advanced Search': ${err}`);
    return false;
  }
};

export const removeRetailPricesForBusinessUnits = (data) => {
  const processConditions = (conditions) => {
    conditions.forEach((condition) => {
      if (condition.rangeFilters) {
        condition.rangeFilters = condition.rangeFilters.filter((filter) => filter.fieldName !== 'retailPrice');
      }
      if (condition.nestedFilterConditions) {
        processConditions(condition.nestedFilterConditions);
      }
    });
  };

  processConditions(data.nestedFilterConditions);
  return data;
};
